<template>
  <component
    :is="component"
    v-bind="{
      title,
      img,
      categoryTitle,
      categoryColor,
      categoryTo,
      to,
      ISODate,
      localeDate,
    }"
  />
</template>

<script>
import { formatToURL } from "@/components/utils.js";
import Default from "./Default.vue";
import Featured from "./Featured.vue";
import Medium from "./Medium.vue";
import Small from "./Small.vue";

const types = {
  default: "Default",
  featured: "Featured",
  medium: "Medium",
  small: "Small",
};

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    img: {
      type: String,
    },
    date: {
      type: String,
    },
    categoryTitle: {
      type: String,
    },
    categoryColor: {
      type: String,
    },
    type: {
      default: "default",
      validator: (v) => Object.keys(types).includes(v),
    },
  },
  computed: {
    component() {
      return types[this.type];
    },
    categoryTo() {
      return `/noticias/${formatToURL(this.categoryTitle)}`;
    },
    to() {
      return `${this.categoryTo}/${formatToURL(this.title)}-${this.id}`;
    },
    dateObject() {
      return this.date && new Date(this.date.replace(" ", "T"));
    },
    ISODate() {
      return this.dateObject?.toISOString();
    },
    localeDate() {
      return this.dateObject?.toLocaleString("pt-BR", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    },
  },
  components: {
    Default,
    Featured,
    Medium,
    Small,
  },
};
</script>
